import { useLanguage } from './useLanguage'

/** Locales that put the app in SEHA Virtual Hospital (Saudi Arabia) mode. */
export const SEHA_LANGUAGES = ['en-SA', 'ar-SA']

/**
 * SEHA Virtual Hospital (Saudi Arabia) mode is driven by the en-SA and ar-SA
 * locales. All SEHA-specific UI behavior must be gated on this hook so other
 * locales keep their existing behavior.
 */
export function useIsSA() {
  const language = useLanguage()
  return SEHA_LANGUAGES.includes(language)
}
